import {
    createSelector
} from 'reselect'

import {
    filter,
    includes,
    sumBy,
    sum,
    pick,
    values,
    reduce,
    map,
    omit
} from 'lodash-es'

import {
    propertyKeys
} from '../reducers'

const getSelections = state => state.selections;
const getRegisteredComponents = state => state.registeredComponents;
const getBoat = state => state.boat;
const getStateWithOnlyTaxonomies = createSelector(
    [state => state],
    (state) => omit(state, ['boat', 'currency', 'selections', 'translations'])
);

export const getSelectedState = createSelector(
    [getStateWithOnlyTaxonomies, getSelections, getRegisteredComponents],
    (state, selections, registeredComponents) => reduce(pick(state, propertyKeys), (result, category, key) => {
        if (includes(registeredComponents, key)) {
            result[key] = {
                ...category,
                options: filter(category.options, item => includes(selections[key], item.id))
            }
        }
        return result;
    }, {})
);

export const getPrices = createSelector(
    [getBoat, getSelectedState],
    (boat, state) => {
        const rv = reduce(state, (result, category, key) => {
            result[key] = sumBy(category.options, v => v.price);
            return result;
        }, {
            boat: boat.price
        });
        return {
            ...rv,
            total: sum(values(rv))
        }
    }
);

export const getDefaults = createSelector(
    [getStateWithOnlyTaxonomies],
    (state) => reduce(state, (result, category, key) => {
        const defaults = map(filter(category.options, item => !item.price), 'id');
        if (defaults.length) {
            result[key] = defaults;
        }
        return result;
    }, {})
);



// WEBPACK FOOTER //
// ./src/selectors/index.js